import { gql } from "@apollo/client";
import { GenericRow } from "../../../../Components/Tables/_Tables/useColumnConstructor";

export const GET_FEED_CURVE_SETTINGS = gql`
  query GetFeedCurveSettings($domain: String!, $feedcurveId: Int!) {
    getFeedCurveSettings(domain: $domain, feedcurveId: $feedcurveId) {
      feedcurve_id
      id: component_id
      component: component_name
      feedSpeed: gram_per_minute
      max_kilo
    }
  }
`;


export const UPDATE_FEED_CURVE_SETTINGS = gql`
  mutation UpdateFeedCurveSettings($domain: String!, $updateFeedCurveSettings: [FeedCurveSettingsInput!]!) {
    updateFeedCurveSettings(domain: $domain, updateFeedCurveSettings: $updateFeedCurveSettings) {
      code
      success
      message
    }
  }
`

export interface FeedCurveSettingsResponse {
  getFeedCurveSettings: FeedCurveSettings[]
}

export interface FeedCurveSettings extends GenericRow {
  feedcurve_id: number;
  id: number;
  component: string;
  feedSpeed?: number;
  max_kilo?: number;
}
